import { render, staticRenderFns } from "./EPayDeclinePage.vue?vue&type=template&id=e806336a&"
import script from "./EPayDeclinePage.vue?vue&type=script&lang=js&"
export * from "./EPayDeclinePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports